module.exports = __webpack_public_path__ + "img/u126.bf766fed.png";